import { createPortal } from 'react-dom';

/**
 * Renders modal overlays at document.body so they sit above layout chrome
 * that lives in a higher stacking context than page content.
 */
export default function ModalPortal({ children }) {
    if (typeof document === 'undefined') return null;
    return createPortal(children, document.body);
}
